<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-4">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'Terms of Service' | translate }}
    </div>
    <mat-select
      class="uppercase !w-20"
      [value]="language"
      (valueChange)="onChangeLanguage($event)"
      [placeholder]="'general.placeholderInput' | translate"
    >
      @for (language of LANGUAGES; track $index) {
        <mat-option [value]="language.label" class="uppercase">{{ language.code }}</mat-option>
      }
    </mat-select>
  </div>

  <div class="w-full h-full flex flex-col gap-3 overflow-hidden">
    <div>
      <xemex-skeleton-block [width]="'80%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'100%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'90%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'45%'" [height]="'16px'"></xemex-skeleton-block>
    </div>
    <div>
      <xemex-skeleton-block [width]="'80%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'100%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'60%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'90%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'25%'" [height]="'16px'"></xemex-skeleton-block>
    </div>
    <div>
      <xemex-skeleton-block [width]="'80%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'100%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'60%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'90%'" [height]="'16px'"></xemex-skeleton-block>
      <xemex-skeleton-block [width]="'25%'" [height]="'16px'"></xemex-skeleton-block>
    </div>
  </div>

  <div class="flex justify-between items-center">
    <button mat-stroked-button (click)="onPrint()">
      {{ 'general.btnPrint' | translate }}
    </button>
    <div class="flex gap-4">
      <button mat-flat-button color="secondary" (click)="onAccept()">
        {{ 'general.btnAccept' | translate }}
      </button>
      <button mat-stroked-button (click)="onDecline()">
        {{ 'general.btnDecline' | translate }}
      </button>
    </div>
  </div>
</div>
